import { useQuery } from 'react-query';
import { url } from './constants';
// todo: make extracting of data typesafe
export var getBusinesses = function () {
    return useQuery('businesses', function () {
        return fetch(url + "/businesses").then(function (res) { return res.json(); });
    });
};
export var getRandomBusiness = function () {
    return useQuery('randomBusiness', function () {
        return fetch(url + "/business/random").then(function (res) { return res.json(); });
    });
};
